import React from 'react';
import { useDispatch } from 'react-redux';

import useComparatorControlPanel from 'utils/hooks/meteorology/comparator/useComparatorControlPanel';
import {
  PeriodOptions,
  setTriggerActivity,
} from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';
import './index.scss';

const PERIOD_OPTIONS: { value: PeriodOptions, label: string }[] = [
  { value: 'd', label: 'Diário' },
  { value: 'p', label: 'Pentada' },
  { value: 's', label: 'Semanal' },
  { value: 'm', label: 'Mensal' },
  { value: 't', label: 'Total' },
];

export default function PeriodSetter() {
  const dispatch = useDispatch();
  const { period: currentPeriod, setComparativePeriod } = useComparatorControlPanel();

  const modifyComparativePeriod = (period: PeriodOptions) => {
    setComparativePeriod(period);
    dispatch(setTriggerActivity(true));
  };

  return (
    <div className="period-selection">
      {PERIOD_OPTIONS.map(({ value, label }) => (
        <button
          key={label}
          className={value === currentPeriod ? 'period-selector-current' : 'period-selector'}
          type="button"
          onClick={() => modifyComparativePeriod(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
